<template>
  <div id="app">
    <!-- Imagem na lateral esquerda centralizada -->
    <img
      :src="imglat"
      alt="Background Esquerdo"
      class="bg-left"
      width="250px"
    />

    <!-- Imagem no canto inferior abaixo -->
    <img
      :src="imgbot"
      alt="Background Inferior"
      class="bg-bottom"
      width="250px"
    />

    <!-- <div class="side-menu">sidemenu</div> -->
    <div>
      <!--

        gtxIdiomasLang: {{ gtxIdiomasLang }}<br />
    gtxProfiler_VisualizarValores: {{ gtxProfiler_VisualizarValores }}
    loadingcount: {{ loadingcount }}<br />
    speechSynthesis: {{ speechSynthesis }}<br />
    alertExpiration: {{ alertExpiration }}<br />
    <b-button variant="info" @click="renewexpires"
      >Testar Expiração de Sessão</b-button
    >

  -->
      <!-- alerta se login expirando -->
      <b-alert
        :show="alertExpiration.show"
        :variant="alertExpiration.variant"
        dismissible
      >
        <b-icon-clock-history
          class="mr-2"
          scale="1.5"
          style="color: lightslategray"
        ></b-icon-clock-history>
        {{ alertExpiration.message }}!
        <b-button class="btn ml-2" variant="success" @click="renewlogin"
          ><b-icon-arrow-repeat class="mr-2"></b-icon-arrow-repeat>Renovar
          sessão</b-button
        >
      </b-alert>

      <MainNavbar ref="MainNavbar" :show="navbar" @menuclick="menuclick">
        <template #rightbuttons>
          <b-nav-item
            v-if="gtxParemp_dataoptions.length > 1 && $isLogged"
            align="right"
            v-b-tooltip.hover
            :title="
              gtxParemp_dataoptions.length > 1 ? gtxParemp_reduzido : 'Empresas'
            "
            v-b-modal.modal-empresas
          >
            <b-icon-building></b-icon-building>
            <b-badge
              pill
              variant="light"
              class="navitembadge"
              style="font-size: 8px"
              >{{ gtxParemp_codigo }}</b-badge
            >
          </b-nav-item>
          <b-nav-item
            v-if="gtxClientes_dataoptions.length > 1 && $isLogged"
            align="right"
            v-b-tooltip.hover
            :title="
              gtxClientes_codigo_cliente > 1
                ? gtxClientes_razaosocial
                : 'Lojistas'
            "
            v-b-modal.modal-lojas
          >
            <b-icon-handbag></b-icon-handbag>
            <b-badge
              v-if="gtxClientes_codigo_cliente > 0"
              pill
              variant="success"
              class="navitembadge"
              style="font-size: 8px"
              >&check;</b-badge
            >
          </b-nav-item>
          <!--
        <b-nav-item-dropdown
          right
          no-caret
          v-if="gtxParemp_dataoptions.length > 1"
          lazy
          v-b-tooltip.hover
          title="Empresas"
        >
          <template v-slot:button-content>
            <b-icon-building />
          </template>
          <b-dropdown-form>
            <b-input-group prepend="Filtro" class="mb-2">
              <b-form-input type="search" v-model="parempfilter"></b-form-input>
            </b-input-group>
          </b-dropdown-form>
          <b-dropdown-form
            style="max-height: 300px; width: 400px; overflow-y: scroll"
          >
            <b-list-group>
              <b-list-group-item
                href="#"
                class="d-flex justify-content-between align-items-center"
                v-for="(paremp, index) of parempnavlist"
                :key="index"
                @click="DefineClienteGlobal(paremp.value)"
              >
                <span
                  :class="
                    paremp.value == gtxParemp_codigo ? 'font-weight-bold' : ''
                  "
                >
                  {{ paremp.text | proper }}
                </span>
                <b-icon-toggle-on
                  variant="success"
                  v-if="paremp.value == gtxParemp_codigo"
                />
                <b-icon-toggle-off variant="info" v-else />
              </b-list-group-item>
            </b-list-group>
          </b-dropdown-form>
        </b-nav-item-dropdown>
      -->
          <!--
        <b-nav-item-dropdown
          :class="screenresize.width > 400 ? 'dropdown-menu-right' : ''"
          no-caret
          v-if="gtxClientes_dataoptions.length > 1"
          lazy
          v-b-tooltip.hover
          title="Lojistas"
          v-if="1 == 2"
        >
          <template v-slot:button-content>
            <b-icon-handbag />
          </template>
          <b-dropdown-form>
            <b-input-group prepend="Filtro" class="mb-2">
              <b-form-input
                type="search"
                v-model="clientesfilter"
              ></b-form-input>
            </b-input-group>
          </b-dropdown-form>
          <b-dropdown-form
            style="max-height: 300px; width: 400px; overflow-y: scroll"
          >
            <b-list-group>
              <b-list-group-item
                href="#"
                class="d-flex justify-content-between align-items-center"
                v-for="(cliente, index) of clientesnavlist"
                :key="index"
                @click="DefineClienteGlobal(cliente.value)"
              >
                <span
                  :class="
                    cliente.value == gtxClientes_codigo_cliente
                      ? 'font-weight-bold'
                      : ''
                  "
                >
                  {{ cliente.text | proper }}
                </span>
                <b-icon-toggle-on
                  variant="success"
                  v-if="cliente.value == gtxClientes_codigo_cliente"
                />
                <b-icon-toggle-off variant="info" v-else />
              </b-list-group-item>
            </b-list-group>
          </b-dropdown-form>
        </b-nav-item-dropdown>
      -->
          <b-nav-item
            align="right"
            href="#"
            v-b-tooltip.hover
            title="Erros"
            v-b-modal.modal-erros
            v-if="bugtoday.length > 0 && pageConfig.MainNavbar.btnError"
          >
            <b-icon-bug class="shakemerotate"></b-icon-bug>
            <b-badge
              pill
              variant="light"
              class="navitembadge"
              style="font-size: 8px"
              >{{ bugtoday.length }}</b-badge
            >
          </b-nav-item>
          <b-nav-item
            align="right"
            href="#"
            v-b-tooltip.hover
            title="Avisos"
            v-b-modal.modal-caixasaida
            v-if="avisoscount > 0 && pageConfig.MainNavbar.btnAvisos"
          >
            <b-icon-bell class="shakemerotate"></b-icon-bell>
            <b-badge
              pill
              variant="light"
              class="navitembadge"
              style="font-size: 8px"
              >{{ avisoscount }}</b-badge
            >
          </b-nav-item>
          <b-nav-item
            align="right"
            href="#"
            v-b-tooltip.hover
            title="Admin"
            v-b-modal.modal-admin
            v-if="mode == 'development' || gtxProfiler_DEV == true"
          >
            <b-icon-tools></b-icon-tools>
          </b-nav-item>
          <b-nav-item
            v-if="$isLogged"
            align="right"
            href="#"
            v-b-tooltip.hover
            title="Configurações"
            v-b-modal.modal-config
          >
            <b-icon-gear></b-icon-gear>
          </b-nav-item>
          <b-nav-item-dropdown
            right
            no-caret
            v-b-tooltip.hover
            :title="$t('Idiomas')"
            v-if="mode == 'development' || gtxProfiler_DEV == true"
          >
            <!-- v-if="mode == 'development' || gtxProfiler_DEV" -->
            <template v-slot:button-content>
              <b-icon-globe2 />
              <!-- <b-badge variant="outline-light" class="float-right">{{
                gtxIdiomasLang
              }}</b-badge> -->
            </template>
            <b-dropdown-item
              href="#"
              v-for="(idioma, index) of gtxIdiomasData"
              :key="index"
              @click="setLocale(idioma)"
            >
              <b-icon-toggle-on
                variant="success"
                v-if="idioma.lang == gtxIdiomasLang"
              />
              <b-icon-toggle-off variant="info" v-else />
              {{ idioma.caption }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <!-- TESTES -->
          <b-nav-item
            align="right"
            href="#"
            v-b-tooltip.hover
            title="Testes"
            v-if="mode == 'development' || gtxProfiler_DEV == true"
            @click="btnteste"
          >
            <!-- v-if="mode == 'development' || gtxProfiler_DEV" -->
            <b-icon-lightning-fill></b-icon-lightning-fill>
          </b-nav-item>
          <b-nav-item
            align="right"
            href="#"
            v-b-tooltip.hover
            title="Speed"
            v-if="mode == 'development' || gtxProfiler_DEV == true"
            @click="btnspeedtest"
          >
            <!-- v-if="mode == 'development' || gtxProfiler_DEV" -->
            <b-icon-speedometer2></b-icon-speedometer2>
          </b-nav-item>
        </template>
      </MainNavbar>

      <!-- gtxIdiomasData: {{ gtxIdiomasData }} <br /> -->

      <SideBarComponent @menuclick="menuclick"></SideBarComponent>

      <LogoLoading :show="showloading" />

      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>

      <!--class="btnScrollTop"-->
      <!-- button to go top -->
      <div class="btnTop">
        <b-button
          pill
          variant="outline-light"
          size="sm"
          v-if="scrollY > 10"
          v-b-tooltip.hover
          title="Topo"
          @click="scrollTop"
        >
          <b-icon-caret-up></b-icon-caret-up>
        </b-button>
      </div>

      <b-alert
        :show="alertmessage !== '' && resourcesdone.length < avisoscount"
        class="position-fixed fixed-bottom m-0 rounded-0"
        style="z-index: 2000"
        variant="warning"
        dismissible
      >
        <b-icon-arrow-clockwise
          class="mr-2"
          scale="1.5"
          animation="spin"
        ></b-icon-arrow-clockwise>
        {{ alertmessage }}
      </b-alert>

      <!-- MODALS -->
      <b-modal
        id="modal-admin"
        ref="modal-admin"
        size="xl"
        hide-footer
        scrollable
        header-bg-variant="danger"
        header-text-variant="light"
        title="Tools"
      >
        <b-card no-body>
          <b-tabs card content-class="mt-3">
            <b-tab title="Vuex Inspector">
              <VuexInspect
                ref="idvuexinspect"
                :namespaces="gtxStoresNames"
              ></VuexInspect>
            </b-tab>
            <b-tab title="Convert Data">
              <Translate></Translate>
            </b-tab>
            <b-tab title="Speaking">
              <SpeechSynthesis ref="speech"></SpeechSynthesis>
            </b-tab>
            <b-tab title="Recognize">
              <Recognition></Recognition>
            </b-tab>
            <b-tab title="Video Download">
              <b-form-group label="Url do vídeo">
                <b-input-group>
                  <b-form-input v-model="videourl"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="outline-secondary" @click="paste()"
                      ><b-icon-clipboard></b-icon-clipboard
                    ></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-button variant="success" @click="baixarvideo()"
                >Baixar</b-button
              >
            </b-tab>
            <b-tab title="Router">
              <b-form-group label="Informe a rota desejada">
                <b-input-group>
                  <b-form-select
                    v-model="rota"
                    :options="rotas"
                    value-field="path"
                    text-field="name"
                  ></b-form-select>
                  <b-input-group-append>
                    <b-button variant="outline-secondary" @click="goroute()"
                      ><b-icon-play-fill></b-icon-play-fill
                    ></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-modal>
      <b-modal
        id="modal-config"
        ref="modal-config"
        size="xl"
        hide-footer
        scrollable
        header-bg-variant="danger"
        header-text-variant="light"
        title="Configurações"
      >
        <b-card no-body>
          <b-tabs
            pills
            card
            justified
            vertical
            nav-wrapper-class="w-25"
            class="text-center"
          >
            <b-tab title="Geral">
              <b-list-group>
                <b-list-group-item class="bg-light">
                  <b-row>
                    <b-col cols="6" class="text-right"
                      >Notificações por voz</b-col
                    >
                    <b-col cols="6" class="d-flex align-items-center"
                      ><b-form-checkbox
                        v-model="pageConfig.voz"
                        switch
                        :disabled="speaking"
                      ></b-form-checkbox
                    ></b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-tab>
            <b-tab title="Barra de Navegação">
              <b-list-group>
                <b-list-group-item class="bg-light">
                  <b-row>
                    <b-col cols="6" class="text-right"
                      >Exibir botão de erros</b-col
                    >
                    <b-col cols="6" class="d-flex align-items-center"
                      ><b-form-checkbox
                        v-model="pageConfig.MainNavbar.btnError"
                        switch
                      ></b-form-checkbox
                    ></b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="6" class="text-right">
                      Exibir botão de ferramentas
                    </b-col>
                    <b-col cols="6" class="d-flex align-items-center"
                      ><b-form-checkbox
                        v-model="pageConfig.MainNavbar.btnTools"
                        switch
                      ></b-form-checkbox
                    ></b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="6" class="text-right">
                      Exibir botão de avisos
                    </b-col>
                    <b-col cols="6" class="d-flex align-items-center"
                      ><b-form-checkbox
                        v-model="pageConfig.MainNavbar.btnAvisos"
                        switch
                      ></b-form-checkbox
                    ></b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-modal>
      <b-modal
        id="modal-caixasaida"
        ref="modal-caixasaida"
        size="xl"
        hide-footer
        scrollable
        header-bg-variant="danger"
        header-text-variant="light"
        :title="`Avisos para ${avisoslistModalTitle}`"
      >
        <div>
          <b-list-group>
            <b-list-group-item
              href="#"
              class="flex-column align-items-start"
              variant="secondary"
              v-for="cx of avisoslist"
              :key="cx.id"
              v-b-toggle="`collapse_avisos${cx.id}`"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Caixa Postal #{{ cx.id }}</h5>
                <small>{{ cx.Data | dateBRHora }}</small>
              </div>

              <p class="mb-1">
                {{ cx.Subject }}
              </p>

              <div class="d-flex flexbottom w-100 justify-content-between">
                <small style="font-style: italic"
                  >De: {{ cx.De }} {{ alerts }}</small
                >
                <b-button
                  size="sm"
                  variant="danger"
                  @click.stop="caixasaidareaded(cx)"
                >
                  Marcar como lido
                </b-button>
              </div>
              <b-collapse :id="`collapse_avisos${cx.id}`">
                <div
                  style="
                    background-color: white;
                    padding: 10px;
                    margin-top: 10px;
                  "
                >
                  <p v-html="cx.Corpo" class="html"></p>
                </div>
              </b-collapse>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-modal>

      <b-modal
        id="modal-erros"
        ref="modal-erros"
        size="xl"
        hide-footer
        scrollable
        header-bg-variant="danger"
        header-text-variant="light"
        title="Log de erros"
      >
        <div>
          <b-list-group>
            <b-list-group-item
              href="#"
              class="flex-column align-items-start"
              variant="secondary"
              v-for="(e, i) of bugtoday"
              :key="i"
            >
              <div
                class="d-flex w-100 justify-content-between"
                v-b-toggle="`collapse_error${i}`"
              >
                <h5 class="mb-1">
                  {{ e.status }} - {{ e.route.path.substr(1) }}
                </h5>
                <small>{{ e.timestamp | dateBRHora }}</small>
              </div>

              <p class="mb-1" v-b-toggle="`collapse_error${i}`">
                {{ e.message }}
              </p>

              <div
                class="d-flex flexbottom w-100 justify-content-between"
                v-b-toggle="`collapse_error${i}`"
              >
                <small style="font-style: italic"
                  >Método: {{ e.config.method }}</small
                >
                <b-button
                  class="btn-icon"
                  size="sm"
                  variant="outline-secondary"
                >
                  <b-icon-caret-down v-if="!e.collapse"></b-icon-caret-down>
                  <b-icon-caret-up v-else></b-icon-caret-up>
                </b-button>
              </div>
              <b-collapse v-model="e.collapse" :id="`collapse_error${i}`">
                <div
                  style="
                    background-color: white;
                    padding: 10px;
                    margin-top: 10px;
                  "
                >
                  <json-viewer
                    :value="e"
                    :expand-depth="5"
                    copyable
                    boxed
                    sort
                  ></json-viewer>
                </div>
              </b-collapse>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-modal>

      <b-modal
        id="modal-lojas"
        ref="modal-lojas"
        hide-footer
        scrollable
        header-bg-variant="danger"
        header-text-variant="light"
        title="Defina a loja padrão"
      >
        <div>
          <b-input-group prepend="Filtro" class="mb-2">
            <b-form-input
              type="search"
              v-model="clientesfilter"
              :state="clientesfilterstate"
            ></b-form-input>
            <b-form-invalid-feedback>
              Nenhum lojista encontrado
            </b-form-invalid-feedback>
          </b-input-group>
          <hr />
          <b-list-group>
            <b-list-group-item
              href="#"
              class="d-flex justify-content-between align-items-center"
              v-for="(cliente, index) of clientesnavlist"
              :key="index"
              @click="DefineClienteGlobal(cliente.value)"
            >
              <span
                :class="
                  cliente.value == gtxClientes_codigo_cliente
                    ? 'font-weight-bold'
                    : ''
                "
              >
                {{ cliente.text | proper }}
              </span>
              <b-icon-toggle-on
                variant="success"
                v-if="cliente.value == gtxClientes_codigo_cliente"
              />
              <b-icon-toggle-off variant="info" v-else />
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-modal>

      <b-modal
        id="modal-empresas"
        ref="modal-empresas"
        hide-footer
        scrollable
        header-bg-variant="danger"
        header-text-variant="light"
        title="Defina a empresa padrão"
      >
        <div>
          <b-input-group prepend="Filtro" class="mb-2">
            <b-form-input
              type="search"
              v-model="parempfilter"
              :state="parempfilterstate"
            ></b-form-input>
            <b-form-invalid-feedback>
              Nenhum empresa encontrada
            </b-form-invalid-feedback>
          </b-input-group>
          <hr />
          <b-list-group>
            <b-list-group-item
              href="#"
              class="d-flex justify-content-between align-items-center"
              v-for="(paremp, index) of parempnavlist"
              :key="index"
              @click="DefineParempGlobal(paremp.value)"
            >
              <span
                :class="
                  paremp.value == gtxParemp_codigo ? 'font-weight-bold' : ''
                "
              >
                {{ paremp.text | proper }}
              </span>
              <b-icon-toggle-on
                variant="success"
                v-if="paremp.value == gtxParemp_codigo"
              />
              <b-icon-toggle-off variant="info" v-else />
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-modal>

      <b-modal
        id="modal-GPT3"
        ref="modal-GPT3"
        hide-footer
        scrollable
        header-bg-variant="danger"
        header-text-variant="light"
        title="Testes com GPT3"
      >
        <div>
          <GPT3></GPT3>
        </div>
      </b-modal>

      <b-modal
        id="modal-speedtest"
        ref="modal-speedtest"
        hide-footer
        scrollable
        size="xl"
        header-bg-variant="danger"
        header-text-variant="light"
        title="Teste seu provedor de internet"
      >
        <div>
          <Speedtest></Speedtest>
        </div>
      </b-modal>

      <b-modal
        id="modal-voice"
        ref="modal-voice"
        hide-footer
        scrollable
        header-bg-variant="danger"
        header-text-variant="light"
        title="Testes com voz"
      >
        <div>
          <Recognition></Recognition>
        </div>
      </b-modal>

      <b-modal
        id="modal-auditlog"
        ref="modal-auditlog"
        :title="gtxAuditCaption"
        size="xl"
        hide-footer
        header-bg-variant="primary"
        header-text-variant="light"
        scrollable
        @hiden="onHideAuditLog"
      >
        <!-- @shown="onShowAuditLog" -->
        <b-alert variant="danger" show v-if="this.gtxAuditErro !== ''">{{
          gtxAuditErro
        }}</b-alert>
        <TableAudit v-else></TableAudit>
      </b-modal>

      <!--
        rota: {{ rota }}<br />
        rotas: {{ rotas }}<br />
      mode: {{ mode }} | dev: {{ dev }}
      gtxCaixasaida_data:
      <pre>
        {{ gtxCaixasaida_data }}
      </pre>
        isLogged: {{ this.$isLogged }}
      {{ alerts }}
      gtxProfiler:
      <pre>
        {{ gtxProfiler }}
      </pre>
      resourcesdone: {{ resourcesdone }} of {{ resources.length }}
      resources: {{ resources }}
      mode: {{ mode }}<br />
      gtxProfiler_DEV: {{ gtxProfiler_DEV }}
      screen: {{ screen }}
      loginExpires: {{ loginExpires }}<br />
      alertExpiresSeconds: {{ alertExpiresSeconds }}<br />
      alertExpiresMessage: {{ alertExpiresMessage }}<br />
    -->
      <!-- <div class="botao-explosao" v-if="confete">
        confetes
        <span class="confete"></span>
        <span class="confete"></span>
        <span class="confete"></span>
        <span class="confete"></span>
      </div> -->

      <!-- <ConfetesExplosion v-model="confete" /> -->
    </div>

    <div
      id="version"
      v-b-tooltip.hover.html="gtxVersionLastHistoryTooltip"
      v-b-tooltip.v-warning.html
      class="pointer"
    >
      {{ gtxVersion }}
    </div>
  </div>
</template>

<script>
import API from "./services/apiservices";
import speech from "./services/speech";
import LogoLoading from "./components/LogoLoading.vue";
import MainNavbar from "./components/MainNavbar.vue";
import SideBarComponent from "./components/SideBarComponent.vue";
import Translate from "./components/Translate.vue";
import VuexInspect from "./components/VuexInspect.vue";
import SpeechSynthesis from "./components/SpeechSynthesis.vue";
import GPT3 from "./components/GPT3.vue";
import Recognition from "./components/Recognition.vue";
// import ConfetesExplosion from "@/components/ConfetesExplosion.vue";
import Speedtest from "@/views/Speedtest.vue";
import TableAudit from "@/components/TableAudit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    LogoLoading,
    MainNavbar,
    SideBarComponent,
    Translate,
    VuexInspect,
    //Ampulheta,
    SpeechSynthesis,
    GPT3,
    Recognition,
    // ConfetesExplosion,
    Speedtest,
    TableAudit,
  },

  data() {
    return {
      imglat: require("@/assets/img/FundoEsquerdo.png"),
      imgbot: require("@/assets/img/FundoDireito.png"),

      mode: process.env.NODE_ENV || "nulo",
      dev: process.env.VUE_APP_DEV || "nulo",
      scrollY: 0,
      screen: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      clientesfilter: "",
      parempfilter: "",
      loadingcount: 0,
      showloading: false,
      focused: false,
      alertmessage: "",
      timerExpiration: 0,
      timerCaixasaida: 0,
      errorCaixasaida: false,
      loginExpires: 0,
      videourl: "",
      pageConfig: {
        voz: null,
        MainNavbar: {
          btnError: true,
          btnTools: false,
          btnAvisos: true,
        },
      },
      pageError: {
        data: [],
      },
      speaking: false,
      resources: [
        {
          message: "Carregando Empresas",
          name: "parempStore",
          action: "actParempGet",
          init: null,
          finish: null,
          source: null,
          error: null,
          done: 0,
        },
        {
          message: "Carregando Marcas",
          name: "marcasStore",
          action: "actMarcasGet",
          init: null,
          finish: null,
          source: null,
          error: null,
          done: 0,
        },
        {
          message: "Carregando Tipos de pedidos",
          name: "tipospedidoStore",
          action: "actTipospedidoGet",
          init: null,
          finish: null,
          source: null,
          error: null,
          done: 0,
        },
        {
          message: "Carregando Consumidores",
          name: "consumidoresStore",
          action: "actConsumidoresGet",
          init: null,
          finish: null,
          source: null,
          error: null,
          done: 0,
        },
        {
          message: "Carregando Clientes",
          name: "clientesStore",
          action: "actClientesGet",
          init: null,
          finish: null,
          source: null,
          error: null,
          done: 0,
        },
        {
          message: "Carregando Ambientes",
          name: "ambientesStore",
          action: "actAmbientesGet",
          init: null,
          finish: null,
          source: null,
          error: null,
          done: 0,
        },
        {
          message: "Carregando Representantes",
          name: "representantesStore",
          action: "actRepresentantesGet",
          init: null,
          finish: null,
          source: null,
          error: null,
          done: 0,
        },
        {
          message: "Carregando Avisos",
          name: "caixasaidaStore",
          action: "actCaixasaidaGet",
          init: null,
          finish: null,
          source: null,
          error: null,
          done: 0,
        },
        {
          message: "Carregando Menus",
          name: "menusStore",
          action: "actMenusGet",
          init: null,
          finish: null,
          source: null,
          error: null,
          done: 0,
        },
        // {
        //   message: "Carregando Consultas",
        //   name: "consultasStore",
        //   action: "actConsultasGet",
        //   getter: "gtxconsultas",
        //   init: null,
        //   finish: null,
        //   source: null,
        //   error: null,
        //   done: 0,
        // },
      ],
      alerts: null,
      confete: false,
      imglat: require("@/assets/img/FundoEsquerdo.png"),
      imgbot: require("@/assets/img/FundoDireito.png"),
      neverexpires: false,
      rota: "",
    };
  },

  created() {
    // console.log("App.created");
    API.post("Authentication/GetAnonymousToken");

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("focus", () => (this.focused = true));
    window.addEventListener("blur", () => (this.focused = false));
    //
    this.actProfilerClear();
    if (this.$isLogged) {
      // console.log("created:", "Está logado");
      this.actCaixasaidaGet(false);
      this.actProfilerGet();
      this.startExpiration();
      this.startCaixasaida();
    }

    // definie um id único para esta sessão
    this.$root.sessionid = this.$root.newid();

    // this.$root.$on("onAppLoading", this.onloading);
  },

  destroyed() {
    // console.log("App.destroyed");
    window.removeEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", () => {});
    window.removeEventListener("focus", () => {});
    window.removeEventListener("blur", () => {});
    //
    this.actCaixasaidaDel();

    this.stopExpiration();
    this.stopCaixasaida();

    this.setlocalDBConfigPage();
    this.$off("speaking", this.handleSpeaking);
  },

  beforeMount() {
    // console.log("App.beforeMount");
    API.loadObserver.subscribe(this.onloading);
    API.errorObserver.subscribe(this.onerror);
    API.loginObserver.subscribe(this.onlogin);
    //

    this.stopExpiration();
    this.stopCaixasaida();
    this.getlocalDBConfigPage();
    this.$on("speaking", this.handleSpeaking);
    this.getlocalDBErrorPage();
    if (this.$isLogged) {
      this.loadresources();
      this.startExpiration();
      this.startCaixasaida();
    }
  },

  beforeUpdate() {
    // console.log("App.beforeUpdate");
  },

  computed: {
    ...mapGetters(["gtxStoresNames"]),
    ...mapGetters("caixasaidaStore", ["gtxCaixasaida_data"]),
    ...mapGetters("parempStore", [
      "gtxParemp_dataoptions",
      "gtxParemp_codigo",
      "gtxParemp_reduzido",
    ]),
    ...mapGetters("clientesStore", [
      "gtxClientes_dataoptions",
      "gtxClientes_codigo_cliente",
      "gtxClientes_razaosocial",
    ]),
    ...mapGetters("profilerStore", [
      "gtxProfiler",
      "gtxProfilerisLogged",
      "gtxProfiler_DisplayName",
      "gtxProfiler_DEV",
      "gtxProfilerRoles",
      "gtxProfiler_Auth",
      "gtxProfiler_Financeiro",
      "gtxProfiler_VisualizarValores",
    ]),
    ...mapGetters("idiomasStore", ["gtxIdiomasData", "gtxIdiomasLang"]),
    ...mapGetters([
      "gtxVersion",
      "gtxAPILoadingShow",
      "gtxVersionLastHistoryTooltip",
    ]),
    ...mapGetters("auditStore", [
      "gtxAuditCaption",
      "gtxAuditTableName",
      "gtxAuditPK",
      "gtxAuditErro",
    ]),

    screenresize() {
      return this.screen;
    },
    avisoscount() {
      // return this.gtxCaixasaida_data.length;
      return this.avisoslist.length;
    },
    avisoslistLength() {
      return this.avisoslist.length; // && this.avisoslist.Subject !== '' ? this.avisos;
    },
    avisoslistModalTitle() {
      return this.avisoslistLength > 0 ? this.avisoslist[0].Para : "";
    },
    // avisoslist() {
    //   return this.gtxCaixasaida_data && this.gtxCaixasaida_data.length > 0
    //     ? this.gtxCaixasaida_data
    //     : [];
    // },
    avisoslist: {
      get() {
        return this.gtxCaixasaida_data && this.gtxCaixasaida_data.length > 0
          ? this.gtxCaixasaida_data.sort((a, b) => b.id - a.id)
          : [];
      },
      set(value) {
        this.alerts = value;
        //console.log("avisoslist:", value);
      },
    },
    SrcY() {
      return window.scrollY;
    },
    navbar() {
      if (
        window.location.pathname == "/homologacao" ||
        window.location.pathname == "/licencaambiental" ||
        window.location.pathname == "/avaliacaofornec"
      ) {
        return false;
      } else {
        return this.$isLogged;
      }
    },
    resourcesdone() {
      return this.resources.reduce((a, b) => a + b.done, 0);
    },
    resourceserror() {
      return this.resourcesdone == this.resources.length
        ? this.resources.filter((f) => f.error)
        : [];
    },
    alertExpiration() {
      let alert = {
        warningseconds: 120,
        dangerseconds: 60,
        show: false,
        message: "",
        variant: "info",
        seconds: 0,
        danger: false,
        warning: false,
      };

      try {
        alert.seconds = parseInt(this.loginExpires / 1000);
        alert.show =
          alert.seconds > 0 &&
          alert.seconds < alert.warningseconds + alert.dangerseconds;
        alert.message = `Sua sessão vai encerrar em ${alert.seconds} segundos`;
        alert.warning = alert.seconds < alert.warningseconds;
        alert.danger = alert.seconds < alert.dangerseconds;
        alert.variant =
          alert.seconds <= alert.dangerseconds ? "danger" : "info";
      } catch (err) {
        alert.error = err.message;
        // console.log("alertExpiration.err:", err);
      }

      return alert;
    },
    voz() {
      return this.pageConfig.voz;
    },
    bugtoday() {
      const hoje = new Date(new Date().setHours(0, 0, 0, 0));
      return this.pageError.data.filter((f) => f.timestamp > hoje);
    },
    clientesnavlist() {
      return this.gtxClientes_dataoptions.filter(
        (f) =>
          f.text.toUpperCase().includes(this.clientesfilter.toUpperCase()) ||
          this.clientesfilter == ""
      );
    },
    parempnavlist() {
      return this.gtxParemp_dataoptions.filter(
        (f) =>
          f.text.toUpperCase().includes(this.parempfilter.toUpperCase()) ||
          this.parempfilter == ""
      );
    },
    clientesfilterstate() {
      return this.clientesfilter == "" ? null : this.clientesnavlist.length > 0;
    },
    parempfilterstate() {
      return this.parempfilter == "" ? null : this.parempnavlist.length > 0;
    },
    rotas() {
      const rotas = this.$router.getRoutes();
      return rotas
        .filter((f) => f.name)
        .map((rota) => ({
          name: rota.name,
          path: rota.path,
          // childs: rota.children
          //   ? rota.children.map((child) => ({
          //       name: child.name,
          //       path: child.path,
          //     }))
          //   : [],
        }))
        .sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    },
  },

  methods: {
    ...mapActions(["actReloadResources", "actScreenResize", "actisLogged"]),
    ...mapActions("parempStore", ["actParempGet", "actParempCodigoSet"]),
    ...mapActions("marcasStore", ["actMarcasGet"]),
    ...mapActions("tipospedidoStore", ["actTipospedidoGet"]),
    ...mapActions("consumidoresStore", ["actConsumidoresGet"]),
    ...mapActions("clientesStore", [
      "actClientesGet",
      "actClientesCodigo_ClienteSet",
    ]),
    ...mapActions("ambientesStore", ["actAmbientesGet"]),
    ...mapActions("representantesStore", ["actRepresentantesGet"]),
    ...mapActions("caixasaidaStore", [
      "actCaixasaidaGet",
      "actCaixasaidaDel",
      "actCaixasaidaUpdate",
    ]),
    ...mapActions("profilerStore", ["actProfilerGet", "actProfilerClear"]),
    ...mapActions("consultasStore", ["actConsultasGet"]),
    ...mapActions("idiomasStore", ["actIdiomasLangSet"]),
    ...mapActions("menusStore", ["actMenusGet"]),
    ...mapActions("auditStore", ["actAuditClear"]),

    doloading: function (load, e) {
      // console.log("APP::doloading:", load);
      e.stopPropagation();
      if (load) {
        this.loadingcount++;
      } else {
        this.loadingcount--;
      }
    },

    navidioma(evt) {
      // console.log("App.navidioma: ", evt);
      this.actIdiomasLangSet(evt.lang);
      // this.$i18n.locale = evt.lang;
      // this.$cookies.set('language', evt.lang);
      // this.$moment.locale(evt.lang);
    },
    notifyclick() {},
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleScroll() {
      this.scrollY = window.scrollY;
    },
    handleResize(event) {
      // console.log("handleResize:", event);
      const screen = {
        width: event.target.innerWidth,
        height: event.target.innerHeight,
      };
      this.screen = screen;
      this.actScreenResize(screen);
    },
    menuclick(menu) {
      // console.log("APP.menuclick.menu:", menu);

      const title = menu.title || menu;

      // console.log("APP.menuclick.menu.title:", title);

      // if (typeof(menu) == 'string')
      switch (title.toUpperCase()) {
        case "EXPIRED":
          this.exit();
          break;
        case "LOGINPROPERTIES":
          this.loginproperties();
          break;
        case "SAIR":
          this.$root
            .showmessage("Deseja realmente encerrar sua sessão ?")
            .then((sim) => {
              if (sim) this.exit();
            });
          break;
        case "LOADRESOURCES":
          this.loadresources();
          break;
      }
    },
    exit() {
      // console.log("exit");
      this.isLogged = false;
      this.$isLogged = false;
      this.actProfilerClear();
      this.stopExpiration();
      this.stopCaixasaida();
      API.logout();
      if (this.$router.path && this.$router.path !== "/")
        this.$router.push("/");
    },
    caixasaidareaded(cx) {
      const caixasaida = { id: cx.id, retorno: cx.Retorno == 0 ? 1 : 0 };
      this.actCaixasaidaUpdate(caixasaida);
    },
    renewlogin(alert = true) {
      API.renewLogin()
        .then(() => {
          if (alert) {
            this.$root.toastsuccess("Sessão renovada com sucesso!");
          }
          this.startExpiration();
          this.startCaixasaida();
        })
        .catch((err) => {
          this.$root.toastdanger(err.message);
        });
    },
    onloading(value) {
      // console.log("App.onloading:", value);
      if (value) {
        this.loadingcount++;
      } else {
        this.loadingcount--;
      }

      this.showloading = this.loadingcount > 0;
      // this.showloading = value;
    },
    onlogin(auth) {
      //if (!this.isLogged && auth) {
      this.actisLogged(auth);
      if (auth) {
        //if (!this.gtxProfiler_Auth) {
        // if (1 == 2) {
        //   this.$root.toastdanger(
        //     "Você não tem permissão para utilizar este sistema. Entre em contato para mais informações."
        //   );
        //   auth = false;
        //   setTimeout(() => {
        //     console.log("onlogin: Deslogando usuário.");
        //     this.exit();
        //   }, 2000);
        // } else {

        // renova também o definie um id único para esta sessão
        this.$root.sessionid = this.$root.newid();

        this.$root.toastsuccess("Autenticado com sucesso");
        // carrega as stores ...
        this.loadresources();
        this.startExpiration();
        this.startCaixasaida();
        // this.actReloadResources();
        this.getlocalDBConfigPage();
        this.getlocalDBErrorPage();
        //}
      }
      if (!auth) {
        if (this.$router.currentRoute.path !== "/") {
          this.$router.push("/");
        }
        this.actCaixasaidaDel();
        this.stopExpiration();
        this.stopCaixasaida();
        this.$cookies.remove("loginexpires");
        this.pageError.data = [];
      }

      this.isLogged = auth;
      this.$isLogged = auth;
    },
    onerror(error) {
      // console.log("App.onerror", error);
      //console.log("App.onerror.status", error.status);
      //console.log("App.onerror.router", this.$router.currentRoute);

      //if (error.status == 401) {
      //  const rota = this.$router.currentRoute.path.replace("/", "");
      //  this.$router.push({
      //    name: "Login",
      //    query: { redir: rota },
      //  });
      //}
      const rota = this.$router.currentRoute.path.replace("/", "");

      if (error.status == 403) {
        this.$root.toastdanger(error.message);
      }
      if (error.status == 404) {
        this.$root.toastdanger(error.message);
      }
      if (error.status == 400) {
        if (error.message) {
          this.$root.toastdanger(error.message);
        } else {
          this.$root.toastdanger(error.data);
        }
      }
      if (error.status == 401) {
        this.$root.toastdanger(error.message);
        this.actCaixasaidaDel();
        this.actProfilerClear();

        if (rota !== "login") {
          this.$router.push({
            name: "Login",
            query: { redir: rota },
          });
        }
      }
      if (error.status == 0) {
        this.$root.toastdanger(error.message);
      }
    },
    checkresources() {
      // console.log("checkresources", this.resourcesdone, this.resources.length);
      if (this.resourcesdone == this.resources.length) {
        this.alertmessage = "";
        // console.log("resources result:", this.resources);
        API.setLocalDBDocument(
          { data: { updated: new Date(), ...this.resources } },
          "resources"
        );
      }
    },
    async loadresource(r) {
      r.init = new Date().toTimeString().substring(0, 8);
      await this[r.action]().then((res, rej) => {
        if (res) {
          r.finish = new Date().toTimeString().substring(0, 8);
          r.source = {
            success: res.success,
            error: res.error,
            updated: res.updated,
            busy: res.busy,
            rows: res.data.length,
          };
          r.done = 1;
        }
        if (rej) {
          r.finish = new Date().toTimeString().substring(0, 8);
          r.error = rej;
          r.done = 1;
          this.alertmessage = rej;
        }
      });
    },
    loadresources() {
      for (const r of this.resources) {
        this.alertmessage = r.message;
        this.loadresource(r);
      }
      // console.log("resources result:", this.resources);
    },
    loginproperties() {
      console.log("resources loginproperties.sessionid:", this.$root.sessionid);
    },
    async getlocalDBConfigPage() {
      await API.getLocalDBDocument("pageConfig").then((doc) => {
        if (doc) {
          // console.log("getlocalDBConfigPage.doc:", doc);
          // this.pageConfig = doc;
          // this.pageConfigvoz = doc.voz || false;
          this.pageConfig.voz = doc.voz || false;
          if (doc.MainNavbar) {
            this.pageConfig.MainNavbar.btnError =
              doc.MainNavbar.btnError || true;
            this.pageConfig.MainNavbar.btnTools =
              doc.MainNavbar.btnTools || false;
            this.pageConfig.MainNavbar.btnAvisos =
              doc.MainNavbar.btnAvisos || true;
          }
        }
      });
    },
    async getlocalDBErrorPage() {
      await API.getLocalDBDocument("pageError").then((doc) => {
        if (doc && doc.data) this.pageError.data = doc.data;
      });
    },
    setlocalDBConfigPage() {
      API.setLocalDBDocument({ data: this.pageConfig }, "pageConfig");
    },
    setLocale(idioma) {
      console.log("APP.setLocale:", idioma);
      this.actIdiomasLangSet(idioma.lang);
      this.$moment.locale(idioma.lang);
      this.$i18n.locale = idioma.lang;
    },
    checkExpiration() {
      const loginexpires = this.$cookies.get("loginexpires");

      // console.log("checkExpiration.appNeverExpiresGet: ",this.$root.appNeverExpiresGet(),"timeexpiration",loginexpires);
      try {
        // this.checkresources();

        //  verifica se ativou o neverexpires
        if (this.$root.appNeverExpiresGet()) {
          this.neverexpires = this.$root.appNeverExpiresGet();
          // console.log("App.checkExpiration.cancel");

          return;
        }

        // console.log("checkExpiration.cookieLogin:", loginexpires);

        if (loginexpires) {
          const dateNow = new Date().getTime();
          const timeRemaining = loginexpires - dateNow;

          // console.log("checkExpiration.timeRemaining:", timeRemaining);

          // console.log("App.checkExpiration.verify");
          this.loginExpires = timeRemaining;

          if (
            this.alertExpiration.seconds == this.alertExpiration.warningseconds
          ) {
            this.$root.toastwarning(
              "Sua sessão vai encerrar em menos de dois minutos."
            );
            this.dospeak(
              "O Grupo K1 informa: Sua sessão vai encerrar em menos de dois minutos!"
            );
          }
          if (
            this.alertExpiration.seconds == this.alertExpiration.dangerseconds
          ) {
            this.$root.toastdanger(
              "Sua sessão vai encerrar em menos de um minuto."
            );
            this.dospeak(
              "O Grupo K1 informa: Sua sessão vai encerrar em menos de um minuto!"
            );
          }
          if (this.alertExpiration.seconds == 0 && this.loginExpires <= 0) {
            this.$root.toastdanger(
              "Sua sessão encerrou, efetue login novamente."
            );
            // é "loguin" mesmo para melhorar a fala
            this.dospeak(
              "O Grupo K1 informa: Sua sessão encerrou, efetue loguin novamente!"
            );
            this.onlogin(false);
            // this.stopExpiration();
            console.log(
              new Date(),
              "Sua sessão encerrou, efetue login novamente."
            );
          }

          //if (timeRemaining >= 0 && timeRemaining <= 60000) {
          // 30 segundos = 30000 milissegundos
          // console.log(
          //   "Seu login vai expirar em",
          //   parseInt(timeRemaining / 10000),
          //   "segundos!"
          // );
          //}
          //if (timeRemaining < 0) {
          // console.log(
          //   "Seu token expirou à",
          //   parseInt((timeRemaining * -1) / 10000),
          //   "segundos..."
          // );
          //}
          //this.stopExpiration();
        } else {
          console.log("checkExpiration.loginexpires:", loginexpires);
          this.stopExpiration();
        }
      } catch (err) {
        console.log("checkExpiration.error:", err.message);
        this.stopExpiration();
        this.stopCaixasaida();
      }
    },
    dospeak(texto) {
      if (this.pageConfig.voz) {
        speech.speak(texto);
      }
    },
    handleSpeaking(speaking) {
      console.log("handleSpeaking:", speaking);
      this.speaking = speaking;
    },
    startExpiration() {
      this.stopExpiration();
      this.timerExpiration = setInterval(() => {
        this.checkExpiration();
      }, 1000);
    },
    stopExpiration() {
      // console.log("stopExpiration");
      if (this.timerExpiration > 0) {
        clearInterval(this.timerExpiration);
      }
      this.timerExpiration = 0;
      this.loginExpires = 0;
    },
    startCaixasaida() {
      return;
    },
    stopCaixasaida() {
      // console.log("stopCaixasaida");
      if (this.timerCaixasaida > 0) {
        clearInterval(this.timerCaixasaida);
      }
      this.timerCaixasaida = 0;
    },
    onShowAuditLog() {
      if (this.gtxAuditErro !== "") {
        this.$refs["modal-auditlog"].hide();
      }
    },
    onHideAuditLog() {
      this.actAuditClear();
    },
    renewexpires() {
      this.$cookies.set(
        "loginexpires",
        new Date().setSeconds(new Date().getSeconds() + 125),
        { expires: "20min" }
      );
      speech.speak("Sua sessão foi renovada com sucesso!");
      this.startExpiration();
      this.startCaixasaida();
    },
    DefineClienteGlobal(codigo) {
      if (this.gtxClientes_codigo_cliente == codigo) {
        this.actClientesCodigo_ClienteSet(null);
        this.$root.toastsuccess("Removido cliente padrão");
      } else {
        this.actClientesCodigo_ClienteSet(codigo);
        this.$root.toastsuccess("Atualizado cliente padrão");
      }
      this.$bvModal.hide("modal-lojas");
    },
    DefineParempGlobal(codigo) {
      this.actParempCodigoSet(codigo);
      this.$root.toastsuccess("Atualizado empresa padrão");
      this.$bvModal.hide("modal-empresas");
    },
    btnteste() {
      console.log("btnTeste.click:hit");
      console.log("btnTeste.sessionid:", this.$root.sessionid);

      // this.confete = true;
      // setTimeout(() => {
      //   this.confete = false;
      // }, 5000);
      // Exibir confetes por 5 segundos
      // this.$bvModal.show("modal-voice");
      // this.explodirConfetes();
      // this.$bvModal.show("modal-GPT3");
      /*
      this.$root.toastdanger("Aguardando timeout");
      API.get("servicos/Teste/Timeout", {
        time: "01/01/1900 00:00:10",
      })
        .then((res) => {
          console.log("res:", res);
          this.$root.toastsuccess("Teminou de aguardando o timeout");
        })
        .catch((error) => {
          console.log("btnteste.catch", error);
        });
      */

      this.mostrarNotificacao(
        "Teste",
        { body: "Esta é uma notificação de exemplo" },
        () => this.notifyclick()
      );
      /*
      this.showloading = true;
      setTimeout(() => {
        this.showloading = false;
      }, 2000);

      API.loadObserver.notify(true);
      setTimeout(() => {
        API.loadObserver.notify(false);
      }, 2000);

      this.$bvToast.toast("teste centralizado", {
        title: "K1 - Soluções",
        autoHideDelay: 5000,
        variant: "primary",
        toaster: "b-toaster-top-center",
        solid: true,
      });
      */
    },
    btnspeedtest() {
      this.$bvModal.show("modal-speedtest");
    },
    explodirConfetes() {
      const confetes = document.querySelectorAll(".confete");
      console.log("APP.explodirConfetes:", confetes);
      this.confete = true;
      confetes.forEach((confete) => {
        confete.style.setProperty("--tx", Math.random() * 200 - 100 + "px");
        confete.style.setProperty("--ty", Math.random() * 200 - 100 + "px");
        confete.style.setProperty("--r", Math.random() * 360 + "deg");
        confete.classList.add("animar-confete");
      });
    },
    baixarvideo(url) {
      const link = `https://galeriadeatalhos.com.br/baixardoyoutube?videolink=${
        url || this.videourl
      }`;
      window.open(link, "_blank");
    },
    async paste() {
      const text = await navigator.clipboard.readText();
      this.videourl = text;
    },
    goroute() {
      if (this.rota !== "") {
        // if (this.rota.substr(0) !== "/") this.rota = "/" + this.rota;
        this.$router.push(this.rota);
      }
    },
  },

  watch: {
    focused(focus) {
      this.$refs.MainNavbar.appFocused(focus);
      this.checkresources();
    },
    avisoscount(count) {
      if (count == 0) {
        this.$bvModal.hide("modal-caixasaida");
      }
    },
    gtxAPILoadingShow(value) {
      // console.log("APP::gtxAPILoadingShow:", value);
      this.onloading(value);
    },
    gtxProfiler_Auth(newVal, oldVal) {
      // console.log("gtxProfiler_Auth:", this.gtxProfiler_Auth);
      // console.log("$isLogged:", this.$isLogged);
      if (newVal == false && oldVal && this.$isLogged) {
        // this.$root.toastdanger(
        //   "Você não tem permissão para utilizar este sistema. Entre em contato para mais informações."
        // );
        // this.onlogin(false);
      }
    },
    gtxClientes_dataoptions: {
      deep: true,
      handler(data) {
        if (data.length == 1) {
          // console.log("APP.watch.gtxClientes_dataoptions:", data);
          this.DefineClienteGlobal(data[0].value);
        }
      },
    },
    pageConfig: {
      deep: true,
      handler() {
        this.setlocalDBConfigPage();
      },
    },
    voz(newVal, oldVal) {
      if (oldVal !== null) {
        if (newVal) {
          speech.speak("Notificações por voz ativado!");
        } else {
          speech.speak("Notificações por voz desativado!");
        }
      }
    },
  },

  destroyed() {
    API.loadObserver.unsubscribe(this.onloading);
    API.errorObserver.unsubscribe(this.onerror);
    API.loginObserver.unsubscribe(this.onlogin);
  },
};
</script>

<style>
@font-face {
  font-family: "Din Pro Regular";
  src: url("assets/fonts/fontsfree-net-dinpro-1.woff2") format("woff2"),
    url("assets/fonts/fontsfree-net-dinpro-1.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

/* Imagem na lateral esquerda centralizada */
.bg-left {
  position: fixed;
  left: 0;
  top: 50%; /* Centraliza verticalmente */
  transform: translateY(-50%);
  z-index: -1;
}

/* Imagem no canto inferior abaixo */
.bg-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.side-menu {
  position: fixed;
  left: 0;
  top: 0;
  width: 250px;
  height: 100%;
  background-color: #333;
  color: #fff;
  padding: 20px;
}

#app {
  font-family: "Din Pro Regular";
  font-size: 16px;
}

body {
  margin: 0;
  padding: 0;
}

h1 {
  color: black;
}

label {
  margin-bottom: 0.2rem !important;
}

.modal-open {
  margin: 0 !important;
  padding-right: 0 !important;
}

.btnScrollTop {
  font-size: 10px;
  height: 29px;
}

.flexbottom {
  align-items: flex-end;
}

.pointer {
  cursor: pointer;
}

.btnTop {
  position: fixed;
  z-index: 9999;
  bottom: 20px;
  right: 30px;
  opacity: 0.4;
}

.btnTop:hover {
  opacity: 1;
}

.spaced > * {
  margin: 2px;
}

.spaced-2 > * {
  margin: 5px;
}

.spaced-4 > * {
  margin: 10px;
}

.navitembadge {
  margin-left: -10px;
  position: absolute;
  bottom: 13px;
}

.buttonbadge {
  margin-left: -10px;
  top: 6px;
}

ul > h4 {
  margin-bottom: 0;
}

.iconbutton {
  padding: 5px;
  border: 1px solid transparent;
  border-radius: 5px;
  cursor: pointer;
}
.iconbutton:hover {
  border-color: silver;
  background-color: lightblue;
}

.btn-badge {
  position: static;
  margin-left: -6px;
}

.btn-icon {
  font-size: 10px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.btn-icon .btn {
  font-size: 10px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.btn-icon:disabled {
  border-color: silver;
  background-color: gainsboro !important;
}
.btn-icon:disabled:hover {
  border-color: silver;
  background-color: gainsboro !important;
}

.iconborder {
  border: 1px transparent;
  border-radius: 3px;
  padding: 1px;
}
.iconborder:hover {
  border: 1px solid;
}
.draggable {
  cursor: move;
}

.draggable.dragging {
  opacity: 0.5;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.azulgradientefraco {
  background-image: linear-gradient(rgb(0, 191, 255), rgb(135, 206, 235));
}
.verdegradiente {
  background-image: linear-gradient(rgb(62, 180, 58), rgb(136, 238, 150));
}

.cinzagradiente {
  background-image: linear-gradient(rgb(72, 81, 86), rgb(72, 81, 86));
  color: white !important;
}

.cinzagradiente .icon {
  color: rgba(255, 255, 255, 0.2) !important;
}

.azulmarinhogradiente {
  background-image: linear-gradient(rgb(68, 199, 199), rgb(180, 223, 230));
}

.goldgradiente {
  background-image: linear-gradient(Gold, rgb(233, 235, 168));
}

.azulgradiente {
  background-image: linear-gradient(rgb(49, 128, 247), rgb(132, 165, 255));
}

.vermelhogradiente {
  background-image: linear-gradient(rgb(247, 66, 66), rgb(241, 144, 144));
  color: white;
}

.laranjagradiente {
  background-image: linear-gradient(rgb(255, 130, 57), rgb(255, 189, 128));
}
.vermelhopadraobutton {
  background-image: linear-gradient(rgba(156, 16, 6), rgba(156, 16, 6));
  color: white;
}

/* ANIMAÇÕES */
.botao-explosao {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.botao-explosao button {
  position: relative;
  z-index: 1;
  padding: 10px 20px;
  background-color: lightblue;
  color: white;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

.botao-explosao .confete {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  animation-name: confete-explodir;
  animation-duration: 2s;
  animation-timing-function: ease-out;
  animation-fill-mode: forwards;
}

/* Imagem na lateral esquerda centralizada */
.bg-left {
  position: fixed;
  left: 0;
  top: 50%; /* Centraliza verticalmente */
  transform: translateY(-50%);
  z-index: -1;
  width: "250px";
}

/* Imagem no canto inferior abaixo */
.bg-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: -1;
  width: "150px";
}

.bg-left {
  position: fixed;
  left: 0;
  top: 50%; /* Centraliza verticalmente */
  transform: translateY(-50%);
  z-index: -1;
  width: "150px";
}

#version {
  position: fixed;
  bottom: 0;
  right: 5px;
  color: whitesmoke;
  font-size: 10px;
  font-style: italic;
}

.spanrightbottomsmall {
  display: flex;
  float: none;
  font-size: 10px;
  text-transform: capitalize;
}

@keyframes confete-explodir {
  0% {
    transform: translate(0, 0) rotate(0);
    opacity: 1;
  }
  100% {
    transform: translate(var(--tx), var(--ty)) rotate(var(--r));
    opacity: 0;
  }
}
.fadecolorgreen {
  animation-name: fadecolorgreen;
  animation-duration: 2s;
}
.shakeme {
  position: relative;
  animation-name: shakeme;
  animation-duration: 0.1s;
  animation-iteration-count: 5;
}
@keyframes shakeme {
  0% {
    transform: translate(0);
  }
  25% {
    transform: translate(-5px, 0);
  }
  50% {
    transform: translate(5px, 0);
  }
  75% {
    transform: translate(-5px, 0);
  }
  100% {
    transform: translate(0);
  }
}
.shakemerotate {
  position: relative;
  animation-name: shakemerotate;
  animation-duration: 0.1s;
  animation-iteration-count: 5;
}
@keyframes shakemerotate {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(-15deg);
  }
  50% {
    transform: rotate(15deg);
  }
  75% {
    transform: rotate(-15deg);
  }
  100% {
    transform: rotate(0);
  }
}
.brilhar {
  animation-name: brilho;
  animation-duration: 2s;
  animation-iteration-count: 5;
}
@keyframes brilho {
  0% {
    text-shadow: 0 0 10px lightgray;
    filter: brightness(1);
  }
  50% {
    text-shadow: 0 0 20px lightblue;
    filter: brightness(2);
  }
  100% {
    text-shadow: 0 0 10px lightgray;
    filter: brightness(1);
  }
}
.blinkhighlight {
  animation-name: sombra-pulsante;
  animation-duration: 1s;
  animation-iteration-count: 2;
}
@keyframes sombra-pulsante {
  0% {
    box-shadow: 0 0 10px rgba(181, 255, 150, 0.5);
  }
  50% {
    box-shadow: 0 0 20px rgba(181, 255, 150, 0.8);
  }
  100% {
    box-shadow: 0 0 10px rgba(181, 255, 150, 0.5);
  }
}
@keyframes fadecolorgreen {
  0% {
    color: inherit;
  }
  50% {
    color: lightgreen;
  }
  100% {
    color: inherit;
  }
}

/* MEDIA QUERIES */
.tableCellSM,
.tableCellMD {
  display: table-cell;
}

@media only screen and (max-width: 800px) {
  .tableCellSM {
    display: none;
  }
  .bg-bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: -1;
    max-width: 150px;
  }
}

@media only screen and (max-width: 1200px) {
  .tableCellMD {
    display: none;
  }
}
</style>
